//---------------
// get surprised
//---------------
export default function getSurprised(combatants) {
  //-----------------------------------------
  // get combatants where surprised (active)
  //-----------------------------------------
  let surprised = combatants.filter((a) => a.surprised == true );
  return surprised;
}
